import React, { useState } from "react";
import Moment from "react-moment";
import {
  Divider,
  Label,
  Image,
  Image as SemanticImage,
  Modal,
  TextArea,
} from "semantic-ui-react";

import { useHistory } from "react-router-dom";

import moment from "moment";
import { toast } from "react-toastify";
import { usePermissionsSimplified } from "../../../../hooks/usePermissionsSimplified";
import { useSelector } from "react-redux";
import { selectTranslations } from "../../../config/i18n/slice";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import UserProfilePlaceholder from "../../../components/common/userProfilePlaceholder";
import Add from "../../WorkOrders/add";
import { CloseIcon, FlagwithFilled } from "../../../../Assets/Icons/svg";
import { updateWorkRequestStatus } from "../../../config/sharedApi/workRequestApis";
import { urlToFile } from "../../../config/api/configApis";
import useModuleFlag from "../../../../hooks/useModuleFlag";
import { LDCONSTANTS } from "../../../config/LDconstants";

const Details = ({
  data,
  setFilterOptions,
  setSelectedDates,
  setSearchTitle,
  untoggle,
  toggleAsideModal,
  setToggleAsideModal,
  targetedData,
  setData,
  setMessage,
  message,
  setmodalWidth,
  modalWidth,
  allIds,
  roleData,
}) => {
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  const userId = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.id;
    } else {
      return null;
    }
  });
  const currentUserLocations = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.locations;
    } else {
      return null;
    }
  });

  const role = useSelector((state) => {
    if (state?.auth?.user?.role?.id) {
      return state?.auth?.user?.role?.type;
    } else {
      return null;
    }
  });

  const currentUserId = [];
  currentUserLocations?.length &&
    currentUserLocations.forEach((location) => {
      if (!currentUserId.some((inv) => inv == location?.id)) {
        currentUserId.push(location?.id);
      }

    });

  const t = useSelector(selectTranslations);
  const {
    userPermissions,
    checkForLinkPermission,
  } = usePermissionsSimplified();
  const history = useHistory();

  const isAssetsEnabled = useModuleFlag(LDCONSTANTS.ASSETS);


  const [refresh, setRefresh] = useState(false);
  const [loader, setloader] = useState(false);

  const [openModal, setModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const confirmWorkRequest = () => {
    if (
      data.attributes.status === "pending" &&
      userPermissions["work-request"]?.assign
    ) {
      return (
        <>
          <div className="comment d-flex justify-content-between p-5 approve-container align-items-center">
            <div className="">
              <span className="user-img font-weight-bold">
                {data?.attributes?.submittedBy?.data?.attributes?.firstName ||
                data?.attributes?.submittedBy?.data?.attributes?.lastName
                  ? data?.attributes?.submittedBy?.data?.attributes?.firstName +
                    " " +
                    data?.attributes?.submittedBy?.data?.attributes?.lastName
                  : t.workRequests.form.unknown}{" "}
                <span className="font-weight-normal">
                  {t.workRequests.form.submitted}
                </span>
                <p className="item-label font-weight-normal">
                  {t.workRequests.form.this_wr}
                </p>
              </span>
            </div>
            <div className="approval-button-container ">
              <button
                className="modal-form-action-button decline "
                onClick={() => {
                  setModal(true);
                }}
              >
                {t.workOrders.details_view.decline}
              </button>

              <button
                onClick={() => {
                  setToggleAsideModal(true);
                }}
                className="modal-form-action-button blue"
              >
                {t.workOrders.details_view.approve}
              </button>
            </div>
          </div>
        </>
      );
    } else if (data.attributes.status === "declined") {
      return data?.attributes?.ardeclinedReason ? (
        <div className="comment decline-container decline-border d-flex justify-content-between approve-container align-items-center">
          <div className="">
            <span className="user-img">
              <div className="">
                <label className="mb-0">
                  {t.common.reason}
                  {":"}
                </label>
                <span className="ml-2 mr-2">
                  {selectedLanguage == "en"
                    ? data?.attributes?.declinedReason
                    : data?.attributes?.ardeclinedReason}
                </span>
              </div>
            </span>
          </div>
        </div>
      ) : (
        <div className="comment decline-container decline-border d-flex justify-content-between approve-container align-items-center">
          <div className="">
            <span className="user-img">
              {t.workRequests.form.declined_statement}{" "}
              <div className="">
                <label className="">
                  {t.common.reason}
                  {":"}
                </label>
                <span className="ml-2 mr-2">
                  {data?.attributes?.declinedReason}
                </span>
              </div>
            </span>
          </div>
        </div>
      );
    } else if (data.attributes.status === "approved") {
      return (
        <div className="comment approved-container approve-border">
          <div className="">
            <span className="user-img font14">
              {t.workRequests.form.approved_statement}
              {checkForLinkPermission("work-order") ? (
                <p
                  onClick={() =>
                    history.push(
                      `/work-orders?id=${data?.attributes?.workOrder?.data?.attributes?.countId}`
                    )
                  }
                  className={`id-text-style work-request font14 ${
                    selectedLanguage == "en" ? "text-left" : "text-right"
                  }`}
                >{`${t.workOrders.details_view.work_order_no} #${data?.attributes?.workOrder?.data?.attributes?.countId}`}</p>
              ) : (
                <p
                  className={`id-text-style font14 ${
                    selectedLanguage == "en" ? "text-left" : "text-right"
                  }`}
                >{`${t.workOrders.details_view.work_order_no} #${data?.attributes?.workOrder?.data?.attributes?.countId}`}</p>
              )}{" "}
            </span>
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  const handleSave = async () => {
    try {
      if (!message) {
        toast.error(t.workOrders.submit_error);
        return;
      }
      setLoading(true);
      let res = await updateWorkRequestStatus(data.id, "declined", message);
      setModal(false);
      setMessage("");
      setLoading(false);
      if (res && res.status == 200) {
        untoggle();
        setFilterOptions({
          requestedBy: [],
          locations: [],
          assets: [],
          priority: [],
          status: [],
          priority: [],
          status: [],
        });

        setSearchTitle("");
        setSelectedDates([]);
        toast.success(
          t.workRequests.work_request +
            " " +
            t.workRequests.form.decline_success
        );
      }
    } catch (error) {
      toast.error(error.message);
      setModal(false);
      setMessage("");
      setLoading(false);
    }
  };

  const renderAssigneePeople = (assigneePeople) => {
    if (assigneePeople?.length > 0) {
      return assigneePeople.map((people, index) => {
        if (people?.attributes?.profileImage?.data?.attributes?.url) {
          return (
            <p className="assignee-wrapper">
              <Image
                key={index}
                avatar
                title={`${people.attributes.firstName} ${people.attributes.lastName}`}
                src={`${people?.attributes?.profileImage?.data?.attributes?.url}`}
                className={`assignee-image ${
                  index !== 0 ? "assignee-offset" : ""
                }`}
              />
              {checkForLinkPermission("people") ? (
                <span
                  onClick={() =>
                    history.push(`/people?id=${people.attributes?.countId}`)
                  }
                  className="detail-intro-link ml-1 mr-1"
                >
                  {people.attributes.firstName +
                    " " +
                    people.attributes.lastName}
                </span>
              ) : (
                <span className=" ml-1 mr-1">
                  {people.attributes.firstName +
                    " " +
                    people.attributes.lastName}
                </span>
              )}
            </p>
          );
        } else {
          return (
            <p>
              <UserProfilePlaceholder
                key={index}
                name={`${
                  people?.attributes?.firstName
                    ? people?.attributes?.firstName
                    : ""
                } ${
                  people?.attributes?.lastName
                    ? people?.attributes?.lastName
                    : ""
                }`}
                width={"34px"}
                height={"34px"}
                right={selectedLanguage == "en" ? "6px" : "-5px"}
              />
              {checkForLinkPermission("people") ? (
                <span
                  onClick={() =>
                    history.push(`/people?id=${people.attributes?.countId}`)
                  }
                  className="detail-intro-link"
                >
                  {people.attributes.firstName +
                    " " +
                    people.attributes.lastName}
                </span>
              ) : (
                <span className="">
                  {people.attributes.firstName +
                    " " +
                    people.attributes.lastName}
                </span>
              )}
            </p>
          );
        }
      });
    } else {
      return t.common.na;
    }
  };

  const priorityOptions = [
    {
      value: "none",
      label: t.workOrders.priority_status.none,
      color: "#788CA5",
    },
    {
      value: "low",
      label: t.workOrders.priority_status.low,

      color: "#4FAB68",
    },
    {
      value: "medium",
      label: t.workOrders.priority_status.medium,

      color: "#E2B203",
    },
    {
      value: "high",
      label: t.workOrders.priority_status.high,

      color: "#D14040",
    },
  ];

  const WRstatusOptions = [
    {
      value: "approved",
      color: "green",
      label: t.workRequests.status.approved,
    },
    {
      value: "pending",
      color: "orange",
      label: t.workRequests.status.pending,
    },
    {
      value: "declined",
      color: "red",
      label: t.workRequests.status.declined,
    },
  ];

  const workOrderPriorityColor = priorityOptions.find(
    (pro) => pro.value == data?.attributes.priority
  );

  const workOrderStatus = WRstatusOptions.find(
    (status) => status.value == data?.attributes.status
  );

  return (
    <div className="preview-details-wrapper">
      <div className="intro">
        <div className="font14">{confirmWorkRequest()}</div>
      </div>
      <div className="data-header mt-5">
        <div className="header-title d-flex justify-content-between align-items-start">
          <div className="header-pill-container d-flex align-items-baseline">
            <p className="detail-title">{data?.attributes?.title}</p>
          </div>
          <div className="header-id d-flex flex-column mb-5">
            <p className={`workorder-intro-value mr-0 ml-0 d-flex gap-3`}>
              <div
                className={`item-value mt-3 ${
                  selectedLanguage == "en" ? "" : "ml-2"
                }`}
              >
                <Label
                  circular
                  empty
                  className="status-label"
                  color={workOrderStatus?.color}
                  size="medium"
                />
              </div>
              <span className="mt-3 status-text">
                {data?.attributes.status ? workOrderStatus?.label : t.common.na}
              </span>
            </p>
          </div>
        </div>
        {data?.attributes.logo?.data?.attributes ? (
          <div
            className={`d-flex justify-content-center align-items-center ${
              data?.attributes?.logo?.data?.attributes?.ext &&
              [".webm", ".mp4", ".hevc", ".mov"].includes(
                data?.attributes?.logo?.data?.attributes?.ext
              )
                ? ""
                : data?.attributes?.logo?.data?.attributes
                ? "logo-container"
                : ""
            }`}
          >
            {data?.attributes?.logo?.data?.attributes?.ext == ".webm" ||
            data?.attributes?.logo?.data?.attributes?.ext == ".mp4" ||
            data?.attributes?.logo?.data?.attributes?.ext == ".hevc" ||
            data?.attributes?.logo?.data?.attributes?.ext == ".mov" ? (
              <video width="500" height={"156"} controls>
                <source
                  src={data.attributes.logo.data.attributes.url}
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            ) : (
              <SemanticImage
                src={
                  data?.attributes.logo?.data?.attributes
                    ? data.attributes.logo.data.attributes.url
                    : toAbsoluteUrl("/media/default-img.png")
                }
                size="medium"
                className={
                  data?.attributes?.logo?.data?.attributes
                    ? "data-header-image"
                    : "no-img"
                }
              />
            )}
          </div>
        ) : null}

        <div className="header-title  mt-5 d-flex justify-content-between align-items-start pb-4">
          <div className="header-pill-container d-flex align-items-baseline">
            <label className="workorder-intro-label work-request-label">
              {t.workOrders.form.description}
              {":"}
            </label>
            <p className="workorder-intro-value">
              {data?.attributes?.description
                ? data?.attributes?.description
                : t.common.na}
            </p>
          </div>
          <div className="header-id d-flex flex-column">
            <div className="">
              <p className={`text-nowrap gap-0 ${data.attributes.priority}`}>
                <FlagwithFilled color={workOrderPriorityColor?.color} />
                <span className="ml-2 mr-2 ">
                  {" "}
                  {workOrderPriorityColor.label}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="details-wrapper work-request mt-0">
        <div className="d-flex align-items-start">
          <label className="workorder-intro-label work-request-label">
            {t.workRequests.form.location}
            {":"}
          </label>
          <p className="workorder-intro-value">
            {data?.attributes?.location?.data ? (
              <React.Fragment>
                {checkForLinkPermission("location") ? (
                  <span
                    className={`detail-intro-link`}
                    basic
                    onClick={() =>
                      history.push(
                        `/locations?id=${data?.attributes?.location?.data?.attributes?.countId}`
                      )
                    }
                  >
                    {data?.attributes?.location?.data?.attributes?.name}
                  </span>
                ) : (
                  <span className=" ml-1 mr-1">
                    {data?.attributes?.location?.data?.attributes?.name}
                  </span>
                )}
              </React.Fragment>
            ) : (
              t.common.na
            )}
          </p>
        </div>
{isAssetsEnabled ? 
        <div className="d-flex align-items-start mt-5">
          <label className="workorder-intro-label work-request-label">
            {t.workRequests.form.assets}
            {":"}
          </label>
          <p className="workorder-intro-value">
            {data?.attributes?.assets?.data?.length
              ? data.attributes.assets.data.map((asset, index) => (
                  <React.Fragment key={index}>
                    {checkForLinkPermission("asset") ? (
                      <p
                        className={`detail-intro-link mb-1 ${
                          selectedLanguage == "en" ? "text-left" : "text-right"
                        }`}
                        basic
                        onClick={() =>
                          history.push(
                            `/assets?id=${asset?.attributes?.countId}`
                          )
                        }
                      >
                        {asset.attributes.name}
                      </p>
                    ) : (
                      <p className={`ml-1 mr-1`} basic>
                        {asset.attributes.name}
                      </p>
                    )}
                  </React.Fragment>
                ))
              : t.common.na}
          </p>
        </div> : null}

        <div className="d-flex align-items-start assignee-details mt-5">
          <label className="workorder-intro-label work-request-label">
            {t.workRequests.form.people}
            {":"}
          </label>
          <p
            className={`workorder-intro-value assignee-name ${
              data?.attributes?.people?.data.length > 0 ? "top-margin" : ""
            }`}
          >
            {renderAssigneePeople(data?.attributes?.people?.data)}
          </p>
        </div>

        <div className="d-flex align-items-start mt-5">
          <label className="workorder-intro-label work-request-label">
            {t.workRequests.form.teams}
            {":"}
          </label>
          <p className="workorder-intro-value">
            {data?.attributes?.teams?.data?.length
              ? data.attributes.teams.data.map((team, index) => (
                  <React.Fragment key={index}>
                    {checkForLinkPermission("team") ? (
                      <p
                        className={`detail-intro-link mb-1 ${
                          selectedLanguage == "en" ? "text-left" : "text-right"
                        }`}
                        basic
                        onClick={() =>
                          history.push(`/teams?id=${team.attributes?.countId}`)
                        }
                      >
                        {team.attributes.name}
                      </p>
                    ) : (
                      <p className={"ml-1 mr-1"} basic>
                        {team.attributes.name}
                      </p>
                    )}
                  </React.Fragment>
                ))
              : t.common.na}
          </p>
        </div>

        <div className="d-flex align-items-start mt-5">
          <label className="workorder-intro-label work-request-label">
            {t.workOrders.form.file}
            {":"}
          </label>
          <p className="workorder-intro-value">
            {data?.attributes?.attachments?.data?.length
              ? data.attributes.attachments.data.map((attachment, index) => (
                  <React.Fragment key={index}>
                    <p
                      className={`detail-intro-link mb-1 ${
                        selectedLanguage == "en" ? "text-left" : "text-right"
                      }`}
                      basic
                      onClick={() => {
                        window.open(attachment?.attributes?.url, "_blank");
                      }}
                    >
                      {attachment?.attributes?.name}
                    </p>
                  </React.Fragment>
                ))
              : t.common.na}
          </p>
        </div>

        <Divider />

        <div className="d-flex align-items-center mt-5">
          <label className="workorder-intro-label work-request-label grey">
            {t.workOrders.table.createdByUser}
            {":"}
          </label>
          <p className="workorder-intro-value set-width grey">
            {data?.attributes?.submittedBy?.data?.attributes?.firstName &&
            data?.attributes?.submittedBy?.data?.attributes?.lastName
              ? data?.attributes?.submittedBy?.data?.attributes?.firstName +
                " " +
                data?.attributes?.submittedBy?.data?.attributes?.lastName
              : t.common.na}
            {", "}
            <Moment format="DD/MM/YYYY LT" date={data?.attributes?.createdAt} />
          </p>
        </div>

        <div className="d-flex align-items-center mt-3">
          <label className="workorder-intro-label work-request-label grey">
            {t.common.update_by}
            {":"}
          </label>
          <p className="workorder-intro-value  set-width  grey">
            {data?.attributes?.updatedByUser?.data
              ? data?.attributes?.updatedByUser?.data?.attributes?.firstName +
                " " +
                data?.attributes?.updatedByUser?.data?.attributes?.lastName +
                ", " +
                moment(data?.attributes?.updatedAt).format("DD/MM/YYYY LT")
              : t.common.na}
          </p>
        </div>
      </div>
      {data?.attributes?.status === "pending" && toggleAsideModal ? (
        <Add
          toggled={toggleAsideModal}
          untoggle={() => {
            untoggle();
            setToggleAsideModal(false);
          }}
          allIds={currentUserId}
          roleData={role}
          currentUserId={userId}
          setmodalPrevWidth={setmodalWidth}
          modalPrevWidth={modalWidth}
          fromWR={true}
          WRFile={
            data?.attributes?.logo?.data
              ? {
                  id: data?.attributes?.logo?.data?.id,
                  file: urlToFile(
                    data?.attributes?.logo?.data?.attributes?.url,
                    data?.attributes?.logo?.data?.attributes?.name
                  ),
                  name: data?.attributes?.logo?.data?.attributes?.name,
                  type: data?.attributes?.logo?.data?.attributes?.mime,
                  cancelPopup: false,
                  isChanged: false,
                }
              : null
          }
          WRAttachmentFile={
            data?.attributes?.attachments?.data
            ? data.attributes.attachments.data.map((logoItem) => ({
                id: logoItem?.id,
                file: urlToFile(
                  logoItem?.attributes?.url,
                  logoItem?.attributes?.name
                ),
                name: logoItem?.attributes?.name,
                type: logoItem?.attributes?.mime,
                cancelPopup: false,
                isChanged: false,
              }))
            : []
          }
          setRefresh={setRefresh}
          WRstatus={data?.attributes?.status}
          refresh={refresh}
          setloader={setloader}
          loader={loader}
          WRtitle={data?.attributes?.title}
          WRdescription={data?.attributes?.description}
          WRpriority={
            data?.attributes?.priority == "none"
              ? ""
              : data?.attributes?.priority
          }
          WRasset={
            data?.attributes?.assets?.data?.length > 0
              ? data.attributes.assets.data.map((el_asset) => el_asset.id)
              : []
          }
          WRlocation={
            data?.attributes?.location?.data?.id
              ? data?.attributes?.location?.data?.id
              : ""
          }
          setWRdata={setData}
          WRordertype="reactive"
          WRID={data?.id}
          handleSuccess={(res) => {
            toast.success(
              t.workRequests.work_request +
                " " +
                t.workRequests.form.approved_success
            );
            setFilterOptions({
              requestedBy: [],
              locations: [],
              assets: [],
              priority: [],
              status: [],

              priority: [],
              status: [],
            });

            setSearchTitle("");
            setSelectedDates([]);

            history.push(`/work-requests?id=${data?.attributes?.countId}`);
          }}
        />
      ) : null}

      <Modal
        className="assets-modal decline-wr-modal"
        size="tiny"
        open={openModal}
        onClose={() => {
          setModal(false);
          setMessage("");
        }}
      >
        <div className={"header-container red"}>
          <span className="assets-header ">
            {t.workRequests.form.decline_wr}
          </span>
          <div>
            <span
              className="c-pointer text-right"
              onClick={() => {
                setModal(false);
                setMessage("");
              }}
            >
              <CloseIcon />
            </span>
          </div>
        </div>

        <Modal.Content>
          <div className="comment-container">
            <label className="comment-label">
              {" "}
              {t.workRequests.form.decline_wr_statement}{" "}
            </label>
            <div className="add-comment">
              <TextArea
                className="comment-textarea"
                rows={5}
                placeholder={t.workOrders.required}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <div
            className={`modal-button-container ${
              selectedLanguage == "en" ? "mr-6" : "ml-10"
            }`}
          >
            <button
              className="modal-form-action-button black"
              onClick={() => {
                setModal(false);
                setMessage("");
              }}
              disabled={loading}
            >
              {t.assets.form.cancel}
            </button>

            <button
              onClick={() => {
                handleSave();
              }}
              disabled={loading}
              className={`modal-form-action-button font-weight-bold light-blue`}
            >
              {t.workOrders.details_view.decline}
            </button>
          </div>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default Details;
